import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authReducers'

// Load state from localStorage
const loadState = () => {
  try {
    const serializedState = localStorage.getItem('reduxState')
    if (serializedState === null) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (err) {
    return undefined
  }
}

// Save state to localStorage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem('reduxState', serializedState)
  } catch (err) {
    // Handle write errors
    console.error('Could not save state', err)
  }
}

const preloadedState = loadState()

const store = configureStore({
  reducer: {
    auth: authReducer
  },
  preloadedState
})

// Subscribe to store changes and save to localStorage
store.subscribe(() => {
  saveState(store.getState())
})

export default store;